import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/data';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 text-background-50 no-underline mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-global-line text-background-50 text-lg"></i>
              </div>
              <span className="text-base font-semibold whitespace-nowrap font-heading">
                日韩在线永久域名
              </span>
            </Link>
            <p className="text-sm text-background-50/60 leading-relaxed">
              {t('common.footerDesc')}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
                {t('nav.home')}
              </Link>
              <Link to="/category/video" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
                {t('nav.categories')}
              </Link>
              <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
                {t('nav.about')}
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">热门分类</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">联系方式</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-background-50/60">
                <i className="ri-mail-line mr-2"></i>contact@rihan-domain.com
              </span>
              <span className="text-sm text-background-50/60">
                <i className="ri-wechat-line mr-2"></i>rihan_domain_official
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-50/40">
              {t('common.footerCopyright')}
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://beian.miit.gov.cn/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-sm text-background-50/40 hover:text-background-50/60 transition-colors"
              >
                粤ICP备2024000000号
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}